import axios from 'axios'

const hostName = window.location.hostname
const hostNameArr = hostName.split('.')
const protocol = window.location.protocol
export function getAppConfig() {
  let baseUrl = '/web'
  if (hostName !== 'localhost') {
    baseUrl = _getRequestUrl(baseUrl)
  }
  return baseUrl
}

// 获取线上的请求路径
function _getRequestUrl(baseUrl) {
  return `${protocol}//inapi.${hostNameArr[1]}.${hostNameArr[2]}${baseUrl}`
}

export function initAxios() {
  service.defaults.baseURL = getAppConfig()
}

// 创建axios实例
const service = axios.create({
  // baseURL: process.env.BASE_API, // api的base_url
  baseURL: '',
  timeout: 60000, // 请求超时时间
  withCredentials: true, // 允许携带cookie
  headers: {
    'Qm-From-Type': hostNameArr[0] === 'localhost' ? 'cy' : hostNameArr[0],
  },
})

// respone拦截器
service.interceptors.response.use(
  // response => response,
  response => {
    const res = response.data
    if (res.status) {
      return response.data
    } else {
      Promise.reject(response.data)
    }
  },
  error => {
    return Promise.reject(error.data)
  }
)

export default service
